import React, {
  useContext,
  useRef,
  useLayoutEffect,
  useState
} from "react";
import { motion } from "framer-motion";
import { ProductsContext } from "../context/products.context";

const YEAR_OPTIONS = [
  { value: "2024", label: "2024" },
  { value: "2023", label: "2023" },
  { value: "2022", label: "2022" },
  { value: "2021", label: "2021" },
  { value: "2020", label: "2020" },
];

const YearSelector = () => {
  const {
    selectedFilterIndicatorDateNew,
    setSelectedFilterIndicatorDateNew,
  } = useContext(ProductsContext);

  // 1) Validate the currently selected option or default to first
  const validSelectedOption =
    YEAR_OPTIONS.find(
      (opt) => opt.value === selectedFilterIndicatorDateNew?.value
    ) || YEAR_OPTIONS[0];

  // 2) Refs
  const containerRef = useRef(null);      // to measure container
  const labelRefs = useRef([]);           // array of label refs

  // 3) Local state for the slider
  const [sliderStyles, setSliderStyles] = useState({ width: 0, left: 0 });

  // 4) Handle radio changes
  const handleYearChange = (event) => {
    const newValue = event.target.value;
    const newOption = YEAR_OPTIONS.find((o) => o.value === newValue);
    setSelectedFilterIndicatorDateNew(newOption);
  };

  // 5) Measure on layout changes
  useLayoutEffect(() => {
    // Which index is selected?
    const currentIndex = YEAR_OPTIONS.findIndex(
      (o) => o.value === validSelectedOption.value
    );
    if (currentIndex < 0) return;

    const labelEl = labelRefs.current[currentIndex];
    const containerEl = containerRef.current;
    if (!labelEl || !containerEl) return;

    // Get bounding rects
    const labelRect = labelEl.getBoundingClientRect();
    const containerRect = containerEl.getBoundingClientRect();

    // Compute left in "container coordinates"
    const left = labelRect.left - containerRect.left;
    const width = labelRect.width;

    setSliderStyles({ left, width });
  }, [validSelectedOption]);

  return (
    <div className="max-w-md mx-auto select-none">
   
  
    {/* Selector */}
    <div className="flex items-center justify-center">
      <div
        ref={containerRef}
        className="relative flex items-center bg-zinc-100 rounded-full border-zinc-200 border p-1 shadow-inner"
      >
        <motion.div
          layout
          transition={{ type: "spring", stiffness: 600, damping: 30 }}
          className="absolute top-1 bottom-1 bg-white rounded-full shadow-md z-0"
          style={{
            left: sliderStyles.left,
            width: sliderStyles.width,
          }}
        />
  
        <fieldset className="relative flex w-full rounded-full gap-x-1">
          <legend className="sr-only">Choose a Year</legend>
          {YEAR_OPTIONS.map((option, idx) => {
            const isSelected = validSelectedOption.value === option.value;
            return (
              <label
                key={option.value}
                ref={(el) => (labelRefs.current[idx] = el)}
                className={`relative z-10 flex flex-1 items-center justify-center
                  rounded-full py-2 px-4 font-medium
                  transition-colors duration-200 ease-in-out cursor-pointer
                  ${
                    isSelected
                      ? "text-zinc-900"
                      : "text-zinc-600 hover:bg-zinc-300"
                  }
                `}
              >
                <input
                  type="radio"
                  name="year"
                  value={option.value}
                  checked={isSelected}
                  onChange={handleYearChange}
                  className="sr-only"
                  aria-label={`Year ${option.value}`}
                />
                {option.label}
              </label>
            );
          })}
        </fieldset>
      </div>
    </div>
  </div>
  );
};

export default YearSelector;